import { useTranslations } from 'next-intl';
import { useProduct } from '../ProductCard';
import { format } from '@monofront/business/utils';

export const ProductPfand = () => {
  const product = useProduct();
  const tCart = useTranslations('Cart');

  if (!product) {
    return (
      <div className="tw-m-2 tw-h-6 tw-w-8/12 tw-animate-pulse tw-rounded-md tw-bg-black-200 tw-grid-area-[pfand]"></div>
    );
  }

  return (
    <p className="tw-text-sm tw-text-black-700 tw-grid-area-[pfand]">
      {tCart('pfandPrice', {
        price: format(product.meta.finance?.pfand ?? 0),
      })}
    </p>
  );
};
